import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Button, Stack} from 'views/components';
import {ChangeCircleOutlined} from 'views/icons';
import {Translate, useNavigate} from 'views/module';

import TimelineCard from './TimelineCard';

import {formatEventDateTime} from '../dateTime';

const ShiftRescheduled = (props) => {
  const {deactivatedData, eventTimezone} = props;

  const navigate = useNavigate();

  const timeString = formatEventDateTime(deactivatedData.timeDeactivated, eventTimezone);
  const newEventRn = deactivatedData.newRescheduleEventRn;

  return (
    <Box>
      <TimelineCard
        timeString={timeString}
        icon={ChangeCircleOutlined}
        iconColor="#cf8842"
        timeBg="#e0e0e0"
        title={<Translate expression='schedule.eventDetail.EventTimelineSection.ShiftRescheduled.DeactivatedTitle' />}
      >
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftRescheduled.DeactivatedDescription' />
          </Typography>

          {
            newEventRn && (
              <Button
                variant="outlined"
                size="small"
                onClick={() => navigate(`/schedule/event/${newEventRn}`)}
                sx={{width: 'fit-content'}}
              >
                <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftRescheduled.ViewNewEvent' />
              </Button>
            )
          }
        </Stack>
      </TimelineCard>
    </Box>
  );
};

ShiftRescheduled.propTypes = {
  deactivatedData: PropTypes.shape({
    description: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
    timeDeactivated: PropTypes.string,
    newRescheduleEventRn: PropTypes.string,
  }),
  eventTimezone: PropTypes.string.isRequired,
};

export default ShiftRescheduled;
